import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageNotFound, PortalInstructions, SubmitPhishPanel, Authorize, Logout } from './pages';
import { AppContainer } from '@ui/components';
import { initSentry } from './sentry';

initSentry();

export const App = () => (
  <AppContainer>
    <Routes>
      <Route path="/" element={<PortalInstructions />}></Route>
      <Route path="/authorize" element={<Authorize />}></Route>
      <Route path="/logout" element={<Logout />} />
      <Route path="/taskpane" element={<SubmitPhishPanel />} />
      <Route path="/taskpane.html" element={<SubmitPhishPanel />} />
      <Route path="*" element={
        <PageNotFound />
      }></Route>
    </Routes>
  </AppContainer>
)
